import { Component, Input,Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'teemapp-table-menu',
  templateUrl: './teemapp-table-menu.component.html',
  styleUrls: ['./teemapp-table-menu.component.css']
})
export class TeemappTableMenuComponent {
	@Output() menuClicked: EventEmitter<any> = new EventEmitter();
  @Output() hideMenu: EventEmitter<any> = new EventEmitter();
	@Input() menuItems: Array<object>;
	@Input() isActive: boolean;
	@Input() itemSelected: Array<any>;

  constructor() { }

}
